import Lotties from '@/components/lotties'
import React from 'react'
import { BrandLogo } from '@/components/common/BrandLogo'

type LoaderProps = {
  size?: string | number
}
export class Loader extends React.Component<LoaderProps> {
  static FullScreen = FullScreenLoader
  static InLine = InLineLoader

  render() {
    return <Lotties name="animation-loading" />
  }
}

function FullScreenLoader() {
  return (
    <div
      className="flex justify-center items-center fixed inset-0 z-[99999] bg-s-backdrop"
      style={{ margin: 0, padding: 0 }}
    >
      <div className="relative flex justify-center items-center">
        <Lotties name="animation-loading" />
        <BrandLogo className="absolute h-20 w-auto max-w-[min(85vw,220px)]" />
      </div>
    </div>
  )
}

function InLineLoader() {
  return (
    <div className="flex items-center justify-center w-full min-h-[180px] bg-transparent">
      <div className="relative flex justify-center items-center">
        <Lotties name="animation-loading" />
        <BrandLogo className="absolute h-14 w-auto max-w-[min(85vw,180px)]" />
      </div>
    </div>
  )
}
